/** @jsx jsx */

import { Fragment as _, memo } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import { colors } from 'styles/variables';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import Transcript from 'components/lib/Video/Transcript';
import SVG from 'components/lib/SVG';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext } from './interactionContext';
import Media from 'components/lib/Media';
import { Block } from 'factories/block';
import getBlockById from 'services/apiHelpers/getBlockById';
import IELayout from 'components/Layouts/IELayout';
import AssessmentIntroduction from './AssessmentIntroduction';
import PDF from 'components/lib/PDF';
import Audio from 'components/lib/Audio';
import Embed from 'components/lib/Embed';
import imagePlaceholder from 'assets/Mid Rectangle.svg';
import shouldUpdate from 'services/shouldUpdate';

const Components = {
  Row,
  Column,
  Text: EditableText,
  AssessmentIntroduction,
  Image: ({ children, ...props }) => {
    return (
      <Image
        {...{
          ...props,
          placeholder: imagePlaceholder,
        }}
      />
    );
  },
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  Video,
  SVG,
  Media,
  Audio,
  EditableButton: null,
  Embed,
  Transcript,
  PDF,
  OpenPDF: ({ children, ...props }) => children,
  ...IELayout(interactionContext),
};

const AssessmentIntroductionDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null } as any}
      >
        {(interactionBlock.children as Block[]).map((child) => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default AssessmentIntroductionDisplay;
